(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["envelope-newsletter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('envelope-newsletter')) {
    class EnvelopeNewsletter extends HTMLElement {
      connectedCallback() {
        this.fields = this.querySelectorAll('.envelope__input, .envelope__submit');
        if (this.hasAttribute('data-open')) {
          this.open();
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            setTimeout(() => this.open(true), reduced ? 0 : 400);
          },
          { threshold: 0.4 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      open(focus = false) {
        this.setAttribute('data-open', '');
        this.fields.forEach((el) => (el.tabIndex = 0));
        if (!focus || !window.matchMedia('(min-width: 750px) and (hover: hover)').matches) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(() => this.querySelector('.envelope__input')?.focus({ preventScroll: true }), reduced ? 0 : 1500);
      }
    }

    customElements.define('envelope-newsletter', EnvelopeNewsletter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coord-showreel')) {
    class CoordShowreel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-coord-slide]'));
        this.backgrounds = Array.from(this.querySelectorAll('[data-slide-bg]'));
        this.index = 0;

        this.querySelector('[data-coord-prev]')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-coord-next]')?.addEventListener('click', () => this.go(this.index + 1));
        this.addEventListener('click', this.onThumbClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addTouch();
        this.updateMediaHeight();
        window.addEventListener('resize', () => this.updateMediaHeight(), { passive: true });

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.started = true;
            this.loadVideo(this.querySelector('.coord__bg-video'));
            this.playSlideVideo();
          },
          { rootMargin: '200px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      loadVideo(video) {
        if (!video || getComputedStyle(video).display === 'none') return;
        if (!video.src && video.dataset.src) video.src = video.dataset.src;
        video.play().catch(() => {});
      }

      playSlideVideo() {
        this.slides.forEach((slide, i) => {
          const video = slide.querySelector('[data-coord-video]');
          if (!video) return;
          if (i === this.index && !video.hidden) {
            this.loadVideo(video);
          } else {
            video.pause();
          }
        });
      }

      go(next) {
        if (!this.slides.length) return;
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => (slide.hidden = i !== this.index));
        this.backgrounds.forEach((img) => (img.dataset.active = String(Number(img.dataset.slideBg) === this.index)));
        if (this.started) this.playSlideVideo();
        this.updateMediaHeight();
      }

      onThumbClick = (event) => {
        const thumb = event.target.closest('[data-coord-thumb]');
        if (!thumb) return;
        const slide = thumb.closest('[data-coord-slide]');
        const target = thumb.dataset.coordThumb;
        slide.querySelector('[data-coord-video]')?.setAttribute('hidden', '');
        slide.querySelector('[data-coord-video]')?.pause();
        slide
          .querySelectorAll('[data-coord-image]')
          .forEach((img) => img.classList.toggle('coord__image--inactive', img.dataset.coordImage !== target));
        slide.querySelectorAll('[data-coord-thumb]').forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
      };

      onKeydown = (event) => {
        if (event.key === 'ArrowLeft') this.go(this.index - 1);
        if (event.key === 'ArrowRight') this.go(this.index + 1);
      };

      addTouch() {
        let startX = null;
        const slides = this.querySelector('.coord__slides');
        slides?.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
        slides?.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const delta = e.changedTouches[0].clientX - startX;
          if (Math.abs(delta) > 40) this.go(this.index + (delta < 0 ? 1 : -1));
          startX = null;
        });
      }

      updateMediaHeight() {
        const media = this.slides[this.index]?.querySelector('.coord__media');
        if (media) this.style.setProperty('--coord-media-height', `${media.offsetHeight}px`);
      }
    }

    customElements.define('coord-showreel', CoordShowreel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-postcards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('postcard-stack')) {
    class PostcardStack extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-postcard]'));
        this.dots = Array.from(this.querySelectorAll('[data-postcard-dot]'));
        this.order = this.cards.map((_, i) => i);
        this.busy = false;
        this.querySelector('[data-postcard-prev]')?.addEventListener('click', () => this.prev());
        this.querySelector('[data-postcard-next]')?.addEventListener('click', () => this.next());
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.postcardDot))));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.prev();
          if (event.key === 'ArrowRight') this.next();
        });
        this.addSwipe();
      }

      get reduced() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      get current() {
        return this.order[0];
      }

      render() {
        this.order.forEach((cardIndex, pos) => {
          const card = this.cards[cardIndex];
          card.dataset.pos = pos;
          card.toggleAttribute('aria-hidden', pos !== 0);
          card.querySelector('.postcards__product')?.setAttribute('tabindex', pos === 0 ? '0' : '-1');
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.current)));
      }

      async swap(card, outFrame, reorder) {
        const from = getComputedStyle(card).transform;
        const lift = card.animate([{ transform: from === 'none' ? 'none' : from }, { transform: outFrame }], {
          duration: 340,
          easing: 'cubic-bezier(0.4, 0, 0.6, 1)',
          fill: 'forwards',
        });
        await lift.finished;
        card.classList.add('is-moving');
        reorder();
        this.render();
        lift.cancel();
        const to = getComputedStyle(card).transform;
        const settle = card.animate([{ transform: outFrame }, { transform: to === 'none' ? 'none' : to }], {
          duration: 520,
          easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
        });
        await settle.finished;
        card.classList.remove('is-moving');
      }

      async next() {
        if (this.cards.length < 2 || this.busy) return;
        this.busy = true;
        const card = this.cards[this.current];
        const reorder = () => this.order.push(this.order.shift());
        if (this.reduced) {
          reorder();
          this.render();
        } else {
          await this.swap(card, 'translate(-62%, -4%) rotate(-12deg)', reorder);
        }
        this.busy = false;
      }

      async prev() {
        if (this.cards.length < 2 || this.busy) return;
        this.busy = true;
        const card = this.cards[this.order[this.order.length - 1]];
        const reorder = () => this.order.unshift(this.order.pop());
        if (this.reduced) {
          reorder();
          this.render();
        } else {
          await this.swap(card, 'translate(62%, -4%) rotate(12deg)', reorder);
        }
        this.busy = false;
      }

      async show(index) {
        while (this.current !== index && !this.busy) {
          await this.next();
        }
      }

      addSwipe() {
        let startX = null;
        const deck = this.querySelector('.postcards__deck');
        deck?.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
        deck?.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const delta = e.changedTouches[0].clientX - startX;
          if (delta < -40) this.next();
          if (delta > 40) this.prev();
          startX = null;
        });
      }
    }

    customElements.define('postcard-stack', PostcardStack);
  }

  } catch(e) { console.error(e); }
})();
})();
